
    (() => {
      'use strict';
      const dialogs = [...document.querySelectorAll('[data-legal-dialog]')];
      let returnFocus = null;
      let switching = false;
      const closeLegal = (dialog) => {
        if (typeof dialog.close === 'function') dialog.close();
        else { dialog.removeAttribute('open'); document.body.classList.remove('legal-open'); if (returnFocus) returnFocus.focus(); }
      };
      const openLegal = (id, trigger) => {
        const dialog = document.getElementById(id);
        if (!dialog || !dialog.hasAttribute('data-legal-dialog')) return;
        if (!dialogs.some(item => item.open)) returnFocus = trigger;
        switching = true;
        dialogs.forEach(item => { if (item.open && item !== dialog) closeLegal(item); });
        if (!dialog.open) {
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
        }
        dialog.scrollTop = 0;
        document.body.classList.add('legal-open');
        dialog.querySelector('[data-legal-close]').focus();
        switching = false;
      };
      document.addEventListener('click', (event) => {
        const link = event.target.closest('a[data-legal-link]');
        if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        openLegal(link.dataset.legalLink, link);
      });
      dialogs.forEach(dialog => {
        dialog.querySelector('[data-legal-close]').addEventListener('click', () => closeLegal(dialog));
        dialog.addEventListener('close', () => {
          if (switching || dialogs.some(item => item.open)) return;
          document.body.classList.remove('legal-open');
          if (returnFocus && document.contains(returnFocus)) returnFocus.focus();
        });
      });
      const initialId = window.location.hash.slice(1);
      if (dialogs.some(dialog => dialog.id === initialId)) openLegal(initialId, null);
    })();
  
(()=>{
const menu=document.getElementById('menu-movil');
const key=document.body.dataset.nacarPage || '';
const navKey=key==='home'?'Inicio':key==='contacto'?'Contacto':key==='sobre'?'Sobre NÁCAR':key==='proyectos'||key.startsWith('proyecto-')?'Proyectos':key==='servicios'||key.startsWith('tarifas-')?'Servicios':'';
document.querySelectorAll('.desktop-nav a,.mobile-nav a').forEach(a=>{if(a.textContent.trim()===navKey)a.setAttribute('aria-current','page');});
document.addEventListener('click',e=>{if(menu&&menu.open&&(!menu.contains(e.target)||e.target.closest('a')))menu.open=false;});
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&menu&&menu.open){menu.open=false;menu.querySelector('summary').focus();}});
let observer;const motion=matchMedia('(prefers-reduced-motion: reduce)');
function reveal(){
 if(observer)observer.disconnect();
 const blocks=[...document.querySelectorAll(".contact-aside,.contact-brief>.eyebrow,.contact-fields,.contact-form-questions,.contact-form>.contact-field,.contact-consent,.contact-questions li,.contact-action,.contact-next,.studio-person>figure,.studio-bio,.studio-approach>*,.studio-focus>*,.studio-process>h2,.studio-process>p,.studio-process li,.wine-landscape,.case-intro,.case-opening>figure,.case-note,.case-gallery>figure,.case-navigation,.portfolio-index,.portfolio-picture,.portfolio-copy,.intro-heading,.intro-copy,.projects-lead,.project,.service,.about-image,.about-copy,.closing,.service-intro,.service-index,.service-visual,.service-story>div,.service-scope>*,.rate-card,.rates-note,.service-end,.faq-heading,.faq-questions"),document.querySelector('.footer-main')].filter(Boolean);
 blocks.forEach(b=>b.classList.remove('is-pending'));
 if(motion.matches||!('IntersectionObserver'in window))return;
 try{observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.remove('is-pending');observer.unobserve(e.target);}}),{threshold:.04,rootMargin:'0px 0px -32px 0px'});
 blocks.forEach(b=>{b.classList.add('scroll-reveal');if(b.getBoundingClientRect().top>=innerHeight-40){b.classList.add('is-pending');observer.observe(b);}});
 }catch{blocks.forEach(b=>b.classList.remove('is-pending'));}
}
document.addEventListener('focusin',e=>{let b=e.target;while(b){if(b.classList)b.classList.remove('is-pending');b=b.parentElement;}});
if(motion.addEventListener)motion.addEventListener('change',reveal);document.addEventListener('shopify:section:load',reveal);window.addEventListener('pageshow',reveal);reveal();
const form=document.getElementById('nacar-contact-form');
if(form){form.querySelectorAll('input[type="text"][required],textarea[required]').forEach(field=>{field.addEventListener('input',()=>field.setCustomValidity(field.value.trim()?'':'Completa este campo.'));});
 const feedback=form.querySelector('.nacar-form-feedback');if(feedback){feedback.focus();}
}
})();
// Mantiene la cabecera legible sobre el contenido al desplazarse.
// Reabre el panel oficial de Shopify sin modificar el consentimiento.
document.addEventListener('click', async (event) => {
  const trigger = event.target.closest('[data-cookie-preferences]');
  if (!trigger) return;
  const error = document.querySelector('[data-cookie-error]');
  if (error) error.hidden = true;
  trigger.disabled = true;
  try {
    if (!window.privacyBanner?.showPreferences) throw new Error('Banner unavailable');
    await window.privacyBanner.showPreferences();
  } catch {
    if (error) error.hidden = false;
  } finally {
    trigger.disabled = false;
  }
});
(() => {
  const header = document.querySelector('.site-header');
  if (!header) return;
  const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 16);
  window.addEventListener('scroll', updateHeader, { passive: true });
  window.addEventListener('pageshow', updateHeader);
  updateHeader();
})();

